import React from 'react'
import T from 'prop-types'
import { Box, Button, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function AssignToBar({ errorNumber, handleAssignTo, readOnly }) {
  const { t } = useTranslation()

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      p={2}
    >
      <Stack direction="row" alignItems="center">
        {errorNumber > 0 && (
          <>
            <Typography
              variant="caption"
              component="span"
              color="textSecondary"
            >
              {t('assignment.car-details.repriceBelow')}
            </Typography>
            <Box pr={0.5} />
            <Typography variant="body2" component="span" color="error">
              {errorNumber}
            </Typography>
          </>
        )}
      </Stack>
      <Button
        color="primary"
        variant="contained"
        disabled={readOnly}
        onClick={handleAssignTo}
      >
        {t('assignment.car-details.assignTo')}
      </Button>
    </Stack>
  )
}

AssignToBar.propTypes = {
  errorNumber: T.number,
  handleAssignTo: T.func,
  readOnly: T.bool,
}
